// extracted by mini-css-extract-plugin
export default {"root-container":"Layout_root-container__bacQ4","header":"Layout_header__JQdXx","footer":"Layout_footer__lMQIg","main-container":"Layout_main-container__aVXKg"};